import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, delay } from 'rxjs';
import { DashboardActions } from './dashboard.actions';
import { DashboardService } from './api/dashboard.service';

export class DashboardEffects {
  private readonly actions$ = inject(Actions);
  private readonly svc = inject(DashboardService);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DashboardActions.loadRequested),
      switchMap(() => this.svc.getMockData().pipe(delay(50))),
      map((data) => DashboardActions.loadSucceeded({ data })),
    ),
  );
}
